/**
 * The "is the app ready to render a conversation" gate, shared by the desktop
 * shell and the phone surface. It lives here rather than on the desktop layout
 * so the phone route can reuse it without pulling the three-column shell (and
 * everything it imports) into its bundle — the phone had a hand-copied twin
 * that had already dropped one of the guards below.
 */

/**
 * FRONT-1101: whether the "Loading your conversation…" gate can stop
 * spinning. `sessionResolve` only ever runs once `onboarded === true`
 * (enabled: auth.authed && onboarded === true in both shells) — so if the
 * onboarded query instead SETTLES INTO AN ERROR (e.g. a 401), `onboarded`
 * stays `undefined` forever, `sessionResolve` stays disabled forever, and
 * this gate used to hang indefinitely even though nothing was in flight.
 * Treating a settled (non-fetching) onboarded-query error as its own way to
 * call the gate done lets the auth gate's own redirect — or the app shell's
 * error surface — take over instead. While the onboarded query is still
 * retrying/fetching, this stays honest and doesn't short-circuit the
 * spinner. Pure so the gate is unit-testable without mounting the layout
 * (same extraction pattern as `shouldShowBriefingFeed` in routes/home.tsx).
 */
export function isSessionReady(input: {
  sessionResolveIsError: boolean;
  sessionResolveIsSuccess: boolean;
  resolvedSessionId: string | null;
  currentSessionId: string | null;
  onboardedIsError: boolean;
  onboardedIsFetching: boolean;
}): boolean {
  if (input.onboardedIsError && !input.onboardedIsFetching) return true;
  return (
    input.sessionResolveIsError ||
    (input.sessionResolveIsSuccess &&
      (input.resolvedSessionId === null ||
        input.currentSessionId === input.resolvedSessionId))
  );
}
